<template>
  <!-- <p class="component-heading" v-if="showone == 'WithoutStockAffectPO' ||
    showone == 'POAmendment' ||
    showone == 'GRN With PO'
    ">
    {{ $t('PurchaseOrder.poname') }}
  </p> -->

  <b-col
    lg="3"
    md="4"
    sm="6"
    v-if="showone == 'POAmendment' || showone == 'WithoutStockAffectPI'"
  >
    <div class="field">
      <label>{{ $t("PurchaseIndent.piid") }}</label>
      <TextField name="" />
    </div>
  </b-col>

  <b-col
    lg="3"
    md="4"
    sm="6"
    v-if="showone == 'POAmendment' || showone == 'WithoutStockAffectPI'"
  >
    <div class="field">
      <label>{{ $t("Request.requestid") }}</label>
      <Dropdown />
    </div>
  </b-col>

  <b-col lg="3" md="4" sm="6">
    <div class="field">
      <CustomDropdown
        :required-icon="true"
        :label="$t('5005.name')"
        v-model="PurchaseformData.SupplierId"
        :disabled="PurchaseformData.disabled"
        :rules="{ required: true }"
        name="Supplier Name"
        id="Supplier Name"
        :items="supcategory"
        :showClear="false"
        @change="change()"
        @update:modelValue="
          getfindonedata, $emit('SupplierId', PurchaseformData.SupplierId)
        "
      />
    </div>
  </b-col>

  <!-- //$emit('emitsupplierval') -->
  <b-col
    lg="3"
    md="4"
    sm="6"
    v-if="
      showone == 'WithoutStockAffectPO' ||
      showone == 'POAmendment' ||
      showone == 'GRN With PO' ||
      DCSelectedDCType == true
    "
  >
    <div class="field">
      <CustomDropdown
        :required-icon="true"
        :label="$t('PurchaseOrder.ponameno')"
        v-model="PurchaseformData.purchase"
        :disabled="PurchaseformData.disabled"
        :rules="{ required: true }"
        :items="dataOptions.purchaseOption"
        :showClear="false"
        @update:modelValue="poOnChange"
      />
    </div>
  </b-col>

  <b-col
    lg="3"
    md="4"
    sm="6"
    v-if="
      (showone == 'GRN Without PO' || showone == 'GRN With PO') &&
      DCNoDropdown.DCNoOption.length != 0
    "
  >
    <div class="field">
      <MultiSelectDropDown
        label="DC No"
        v-model="DCNoDropdown.DCNoId"
        :disabled="PurchaseformData.disabled"
        :rules="{
          required:
            (showone == 'GRN With PO' || showone == 'GRN Without PO') &&
            DCNoDropdown.DCNoOption.length != 0
              ? false
              : true,
        }"
        :required-icon="
          (showone == 'GRN With PO' || showone == 'GRN Without PO') &&
          DCNoDropdown.DCNoOption.length != 0
            ? false
            : true
        "
        name="DC No"
        id="DC No"
        :items="DCNoDropdown.DCNoOption"
        :showClear="false"
        @update:modelValue="DCNochange"
      />
    </div>
  </b-col>

  <b-col
    lg="3"
    md="4"
    sm="6"
    v-if="showone == 'POAmendment' || showone == 'GRN With PO'"
  >
    <div class="field">
      <!-- <span class="fieldlabel">{{ $t('PurchaseOrder.date') }}</span> -->
      <!-- <label>{{ $t('PurchaseOrder.date') }}</label> -->
      <Datepicker
        :disabled="true"
        v-model="PurchaseformData.CreatedAt"
        :label="$t('PurchaseOrder.date')"
      />
    </div>
  </b-col>

  <b-col lg="3" md="4" sm="6" v-if="displayterms">
    <div class="field">
      <CustomDropdown
        :label="$t('5005.paymentterms.terms')"
        v-model="PurchaseformData.PaymentTermsId"
        name="PAYMENT TERMS"
        id="PAYMENT TERMS"
        :items="paymentcategory"
        @update:modelValue="PaymentFunction"
      />
    </div>
  </b-col>
  <b-col lg="3" md="4" sm="6" v-if="displayterms">
    <div class="field">
      <CustomDropdown
        :label="$t('5005.DeliveryTerms')"
        v-model="PurchaseformData.DeliveryTermsId"
        name="DELIVERY TERMS"
        id="DELIVERY TERMS"
        :items="deliverycategory"
        @update:modelValue="DeliveryFunction"
      />
    </div>
  </b-col>
  <!-- <b-col lg="3" md="4" sm="6" v-if="showone == 'GRN Without PO' ||
    showone == 'GRN With PO' ||
    showone == 'Opening Stock' ||
    showone == 'DC'
    ">
      <div class="field">
        <TextField :label="$t('invoice.invoicenumber')" v-model="PurchaseformData.InvoiceNo" type="text" clearable name="Invoice Number"
          @update:modelValue="invoiceupdate" :rules="{ required: true }" :required-icon=true id="InvoiceNumber" />
      </div>
    </b-col>
    <b-col lg="3" md="4" sm="6" v-if="showone == 'GRN Without PO' ||
    showone == 'GRN With PO' ||
    showone == 'Opening Stock' ||
    showone == 'DC'
    ">

      <div class="field">
        <Datepicker :maxDate="maxDate" v-model="PurchaseformData.InvoiceDate" @update:modelValue="invoiceupdate" :label="$t('invoice.invoicedate')"
          name="Invoice Date" id="Invoice Date" dateFormat="dd-mm-yy" />
      </div>
    </b-col> -->

  <!-- <div> -->

  <div
    class="position-relative sipplierpopover"
    v-if="PurchaseformData.SupplierId"
  >
    <b-button id="popover-target-1" class="supplier-toggle link-txt">
      View Details
    </b-button>

    <b-popover target="popover-target-1" triggers="focus" placement="bottom">
      <div class="SupplierCard">
        <div class="suppliercardcontent">
          <b-row class="p-3">
            <b-col xl="10" lg="10" md="10" sm="10" cols="10">
              <h6>{{ PurchaseformData.SupplierName }}</h6>
              <p class="py-3" v-if="Data.Address">{{ Data.Address }}</p>
            </b-col>

            <b-col
              class="d-flex flex-row-reverse"
              xl="2"
              lg="2"
              md="2"
              sm="2"
              cols="2"
            >
              <!-- <p>
                <i
                  class="pi pi-external-link"
                  style="color: #0a82ff; cursor: pointer"
                  @click="RowClick"
                ></i>
              </p> -->
              <p v-if="Param == 'PO'">
                <i
                  class="pi pi-trash me-2"
                  style="color: red"
                  @click="DeleteSupplier()"
                ></i>
                <i
                  class="pi pi-pencil me-2"
                  @click="EditSupDet = !EditSupDet"
                ></i>
              </p>
            </b-col>
          </b-row>
          <b-row class="p-3" v-if="cardshow">
            <b-col>
              <h6>{{ $t("5005.paymentterms.terms") }}</h6>
              <div class="contentbg" v-if="!EditSupDet">
                <p>
                  {{ PurchaseformData.PaymentTermsName }}
                </p>
              </div>
              <div class="label-d-none field" v-else>
                <Textarea
                  v-model="PurchaseformData.PaymentTermsName"
                  name="PaymentTextarea"
                  label=""
                  :rules="{ required: false }"
                  id="PaymentTextarea"
                  ref="PaymentTextarea"
                />
              </div>
            </b-col>
            <b-col>
              <h6>{{ $t("5005.DeliveryTerms") }}</h6>
              <div class="contentbg" v-if="!EditSupDet">
                <p>{{ PurchaseformData.DeliveryTermsName }}</p>
              </div>
              <div class="label-d-none field" v-else>
                <Textarea
                  v-model="PurchaseformData.DeliveryTermsName"
                  name="deliveryTextarea"
                  label=""
                  :rules="{ required: false }"
                  id="deliveryTextarea"
                  ref="deliveryTextarea"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="SupplierCardgst p-3 mt-3">
          <b-row>
            <b-col class="d-flex align-items-center">
              <span>{{ $t("5005.gst") }}:</span>
              <span>{{ Data.GST }}</span>
            </b-col>
            <b-col class="d-flex flex-row-reverse" v-if="Data.GST !== ''">
              <p class="mb-0">
                <i
                  ref="copyButton"
                  class="pi pi-copy copyicon"
                  v-b-tooltip="{
                    title: tooltipContent,
                    triggers: ['hover', 'focus'],
                  }"
                  @click="copyGST"
                ></i>
              </p>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-popover>
  </div>

  <!-- </div> -->
</template>

<script lang="ts">
import { defineComponent, ref, reactive, watch, onMounted } from "vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import Datepicker from "../../../../components/FormComponents/DatePicker.vue";
import CustomDropdown from "../../../../components/FormComponents/Dropdown.vue";
import MultiSelectDropDown from "../../../../components/FormComponents/MultiSelectDropdown.vue";
import commonservice from "../../Service/WithoutStockAffectService";
import AutoCompleteCustom from "../../../../components/FormComponents/AutoComplete.vue";
import service from "../../../../modules/Inventory/Service/SupplierMaster";
import RateContractService from "../../../../modules/Inventory/Service/RateContractService";
import { useToast } from "primevue/usetoast";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import DeliveryTermsService from "../../../../modules/Inventory/Service/DeliveryTermsService";
import StockInService from "../../../../modules/Inventory/Service/StockInService";

// import { isLeftClick } from "handsontable/helpers/dom";
export default defineComponent({
  props: {
    showone: {
      type: String,
      default: "",
    },
    commonItemProps: {
      type: Object,
      default: {},
    },
    modelValue: {
      type: Object,
    },
    POId: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    storeDetails: {
      type: Object,
      default: {},
    },
    supplierDeatails: {
      type: Object,
      default: {},
    },
    cardshow: {
      type: Boolean,
      default: true,
    },
    value: {},
    IsSupEdit: {
      type: Number,
      default: 0,
    },
    SupplierId: {
      type: Number,
      default: 0,
    },
    SelectedDCType: {
      type: Number,
      default: 0,
    },
    IsGRNApproval: {
      type: Object,
      default: {},
    },
  },

  components: {
    TextField,
    Datepicker,
    CustomDropdown,
    MultiSelectDropDown,
    AutoCompleteCustom,
  },
  setup(props, { emit }) {
    /*Variable Declaration*/
    const dataOptions: any = ref({
      purchaseOption: [],
      // purchaseName: ''
    });

    const PurchaseformData = reactive({
      purchaseId: 0,
      purchaseName: "",
      purchase: ref(),
      disabled: false,
      SupplierId: ref(),
      SupplierName: "",
      StateId: 0,
      PaymentTermsId: ref(),
      DeliveryTermsId: ref(),
      AdditionalTerms: "",
      Reference: "",
      BillingAddress: "",
      Email: "",
      PaymentTermsName: "",
      DeliveryTermsName: "",
      InvoiceNo: "",
      InvoiceDate: "",
      CreatedAt: "",
    });
    const router = useRouter();
    const route = useRoute();
    const toast = useToast();
    const showText = ref(false);
    const SupplierCard = ref(false);
    const tooltipContent = ref("Copy GST");
    const supDisabled = ref(false);
    const poDisabled = ref(false);
    let DCSelectedDCType = ref(false);
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    const EditSupDet = ref(false);
    const maxDate = ref(new Date());
    const Param = route.query.param;

    let ItemsBySupplierId = reactive([]);

    const form = ref({});

    let EditID = 1;
    var supcategory = ref();
    var paymentcategory = ref();
    var deliverycategory = ref();
    let data1;
    let displayterms = ref(false);
    //const Param = route.query.param;
    let StoreBranchId = route.query.BranchId;

    watch(
      () => props.IsGRNApproval,
      (NewIsGRNApprovalObj) => {
        debugger;
        if (NewIsGRNApprovalObj.IsApproval == 1) {
          StoreBranchId = NewIsGRNApprovalObj.BranchId ?? 0;
        }
      },
      { immediate: true, deep: true }
    );

    const Data = reactive({
      Address: "",
      Paymentterms: "",
      deliveryterms: "",
      suppliername: "",
      GST: "",
    });
    // let SupformData = reactive({
    //   SupplierId: ref(),
    //   SupplierName: "",
    //   StateId: 0,
    //   PaymentTermsId: ref(),
    //   DeliveryTermsId: ref(),
    //   AdditionalTerms: "",
    //   Reference: "",
    //   BillingAddress: "",
    //   Email: "",
    //   PaymentTermsName: "",
    //   DeliveryTermsName: "",
    // });
    watch(
      () => PurchaseformData.SupplierId,
      (newVal) => {
        debugger;
        // if (props.supplierDeatails.value == null || props.supplierDeatails.value == undefined) {
        //   PurchaseformData.purchase = "";
        //   PurchaseformData.CreatedAt = "";
        //   poItems.value = [];
        //   emit("getPoItems", poItems);
        // }
        debugger;
        if (newVal) {
          dataOptions.value.purchaseOption = [
            {
              name: PurchaseformData.purchaseName,
              value: PurchaseformData.purchaseId,
            },
          ];
          PurchaseformData.purchase = PurchaseformData.purchaseId;

          getfindonedata();
        }
        supplierupdate();
      }
    );
    watch(props, (newValue) => {
      debugger;
      console.log(newValue.supplierDeatails);
      if (newValue)
        if (newValue.supplierDeatails.length > 0)
          PurchaseformData.SupplierId =
            newValue.supplierDeatails[0]["SupplierId"];
      getfindonedata();
      supplierupdate();
    });

    onMounted(() => {
      supDisabled.value = false;
      Object.assign(PurchaseformData, props.value);
      if (Param == "PO" || Param == "POAmendment") {
        loadPaymentTerms();
        loadDeliveryTerms();
      }
      supplierupdate();
      const copyButton = document.querySelector(".pi-copy");
      if (copyButton) {
        copyButton.addEventListener("focus", () => {
          tooltipContent.value = "Click to copy";
        });
        copyButton.addEventListener("mouseleave", () => {
          tooltipContent.value = "Copy GST";
        });
      }
    });

    watch(props, async (newValue) => {
      debugger;
      Object.assign(PurchaseformData, newValue.modelValue);
      if (newValue.POId) {
        await POItemLoad(newValue.POId);
      }
      supplierupdate();

      //LoadItem();
    });

    let StoreId = Number(props.commonItemProps?.storeId) ?? 0;
    let StoreBranchMapId = Number(props.commonItemProps?.StoreBrMapId) ?? 0;
    /*--*/

    /*Method calls*/
    //ListPurchaseOrder()
    /*--*/

    /*Method Declaration*/
    async function ListPurchaseOrder() {
      debugger;
      try {
        if (PurchaseformData.SupplierId != 0) {
          let result;

          if (props.showone == "DC" && props.SelectedDCType == 3) {
            result = await commonservice.GetPOBySupplierId(
              PurchaseformData.SupplierId,
              StoreBranchMapId,
              "4,5,6"
            );
          } else {
            result = await commonservice.GetListBySupplierId(
              PurchaseformData.SupplierId,
              StoreBranchMapId,
              "4,5,6"
            );
          }

          console.log(result["result"]);

          dataOptions.value.purchaseOption = result["result"]

            .filter((item) => {
              if (item.DocType === "4" || item.DocType === "5") {
                return (
                  item.Status != 2 &&
                  item.Status != 4 &&
                  item.Status != 5 &&
                  item.IsApproved == 1 &&
                  item.IsDraft != 1 &&
                  item.Status != 1
                );
              } else {
                return (
                  item.Status != 2 &&
                  item.Status != 4 &&
                  item.Status != 5 &&
                  item.IsDraft != 1 &&
                  item.Status != 1
                );
              }
            })
            .map((item) => {
              if (item.Status == 3 && item.IsDraft != 1) {
                item.name =
                  item.PODocNo +
                  " - " +
                  "Rs." +
                  item.Amount +
                  " - " +
                  item.DocDateHR +
                  " - " +
                  "Partially";
              } else {
                item.name =
                  item.PODocNo +
                  " - " +
                  "Rs." +
                  item.Amount +
                  " - " +
                  item.DocDateHR;
              }
              item.value = item.Id;
              return item;
            });
        }
      } catch (error) {}
    }

    function update() {
      emit("update:modelValue", PurchaseformData);
    }

    const poItems: any = ref([]);
    async function poOnChange(data) {
      debugger;
      if (data) {
        let poId = JSON.stringify(data);
        let POData = dataOptions.value.purchaseOption.filter(
          (items) => items.Id == data
        );
        dataOptions.value.purchaseOption.forEach((element) => {
          if (element["Id"] == JSON.stringify(data)) {
            PurchaseformData.purchaseName = element["PORefNo"];
            PurchaseformData.CreatedAt = element["CreatedAt"];
          }
        });
        await POItemLoad(poId);
      }
    }

    async function POItemLoad(poId) {
      debugger;

      if (poId) {
        PurchaseformData.purchaseId = poId;

        let responsetable;
        if (props.showone == "DC" && props.SelectedDCType == 3) {
          responsetable = await commonservice.GetPOItemsByPOId(poId);
        } else {
          DCNoDropdown.value.DCNoId = null;
          DCNoDropdown.value.DCNoOption.length = 0;
          await LoadDCNo(poId, "PO");

          if (DCNoDropdown.value.DCNoOption.length > 0) {
            // responsetable = await commonservice.GetPOItemsByPOId(poId);
            responsetable = await commonservice.GetStockWODetailsById(poId);
          } else {
            responsetable = await commonservice.GetStockWODetailsById(poId);
          }
        }

        poItems.value = responsetable["result"].map((i1) => {
          i1.RequestedQty = i1.ItemQuantity;
          i1.IsFreeItem = 0;
          i1.StockDetailsId = 0;

          //i1.Totalvalue = Number(i1.Amount).toFixed(2);
          // i1.Rate = 0;
          // i1.Discount = i1.ItemDiscount;
          // i1.DiscountAmount = i1.ItemDiscountAmount;
          let BeforeDiscountRate = i1.Rate;

          const discountAmount = ((i1.ItemDiscount || 0.0) / 100) * i1.Rate;
          i1.Discountamount = discountAmount.toFixed(2);

          i1.Rate = (i1.Rate - i1.Discountamount).toFixed(2);

          i1.Purchasetaxamount = (
            i1.Rate *
            (i1.PurchasePercentage / 100)
          ).toFixed(2);

          if (i1.SGSTTax && i1.CGSTTax) {
            i1.SGSTTaxAmount = Number(Number(i1.Purchasetaxamount) / 2).toFixed(
              2
            );

            i1.CGSTTaxAmount = Number(Number(i1.Purchasetaxamount) / 2).toFixed(
              2
            );
          }

          if (i1.IGSTTax) {
            i1.IGSTTaxAmount = Number(
              (i1.PurchasePercentage * i1.Rate) / 100
            ).toFixed(2);
          }

          i1.Rate = BeforeDiscountRate;

          i1.Totalvalue = Number(
            Number(i1.Rate) -
              Number(i1.Discountamount) +
              Number(i1.Purchasetaxamount) +
              Number(i1.servicecharges || 0.0) +
              Number(i1.othercharges || 0.0)
          ).toFixed(2);

          return i1;
        });

        emit("getPoItems", poItems);
        update();
      }
    }
    function supplierupdate() {
      emit("update:modelValue", PurchaseformData);
    }

    async function getfindonedata() {
      debugger;
      try {
        debugger;
        if (PurchaseformData.SupplierId != null) {
          let SupplierName = supcategory.value.filter(
            (item) => item.Id == PurchaseformData.SupplierId
          );
          console.log(SupplierName);
          console.log(SupplierName[0].name);
          PurchaseformData.SupplierName = SupplierName[0].name;
          PurchaseformData.StateId = SupplierName[0].State;
          PurchaseformData.Email = SupplierName[0].Email;
          if (props.IsSupEdit == 0) {
            PurchaseformData.BillingAddress = SupplierName[0].AddressVar;
            PurchaseformData.AdditionalTerms = SupplierName[0].AdditionalTerms;
            PurchaseformData.Reference = SupplierName[0].Reference;
          }
          debugger;
          let response = await service.EditData(PurchaseformData.SupplierId);

          data1 = response["result"];
          console.log(data1);
          Data.Address = response["result"][0]["Address"];
          Data.GST = response["result"][0]["GSTNO"];
          if (props.IsSupEdit == 0) {
            PurchaseformData.PaymentTermsName =
              response["result"][0]["PaymentTermsDesc"];
            PurchaseformData.DeliveryTermsName =
              response["result"][0]["DeliTermsDesc"];
          }

          supplierupdate();
          let StoreId = route.query.StoreId;
          let Id = route.query.Id;
          let responseitem =
            await RateContractService.getitemsbySupplierIdStoreId(
              PurchaseformData.SupplierId,
              StoreId,
              HospitalId
            );
          ItemsBySupplierId = responseitem["result"];
          emit("item-update", ItemsBySupplierId);
          if (Param == "PO" || Param == "POAmendment") {
            displayterms.value = true;
          }

          // SupformData.value.Paymentterms = response['result']

          // Object.keys(Data.value).forEach((key) => {
          //   if (data1[key]) Data.value[key] = data1[key];
          // });
          //emit("SupplierId", SupformData.SupplierId);
          SupplierCard.value = true;
        } else {
          SupplierCard.value = false;
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function suppliercategorydd() {
      debugger;
      try {
        const dataresponse = await service.GetSuppliersByStoreId(
          props.commonItemProps.storeId ?? 0,
          StoreBranchId
        );
        console.log(dataresponse);
        supcategory.value = dataresponse["result"]
          .filter((i1) => i1.IsActive == true)
          .map((item: any) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    async function loadPaymentTerms() {
      debugger;
      try {
        const dataresponse = await service.getpaymentstermsdd();
        console.log(dataresponse["result"]);
        paymentcategory.value = dataresponse["result"]
          .filter(
            (items) =>
              items.HospitalId == HospitalId && items.BranchId == BranchId
          )
          .map((item) => {
            item.name = item.PaymentTermsDesc;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    async function loadDeliveryTerms() {
      debugger;
      try {
        const dataresponse = await DeliveryTermsService.getdata();
        console.log(dataresponse["result"]);
        deliverycategory.value = dataresponse["result"]
          .filter(
            (i1) =>
              i1.IsActive == true &&
              i1.HospitalId == HospitalId &&
              i1.BranchId == BranchId
          )
          .map((item) => {
            item.name = item.DeliTermsDesc;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    function PaymentFunction(value) {
      debugger;
      if (value) {
        PurchaseformData.PaymentTermsName = (
          paymentcategory.value.find((item) => item.Id === value) || {}
        ).name;
      }
    }

    function DeliveryFunction(value) {
      debugger;
      if (value) {
        PurchaseformData.DeliveryTermsName = (
          deliverycategory.value.find((item) => item.Id === value) || {}
        ).name;
      }
    }

    const copyGST = async () => {
      debugger;
      try {
        await navigator.clipboard.writeText(Data.GST);
        console.log("Copied to clipboard:", Data.GST);
        tooltipContent.value = "Copied!";
      } catch (error) {
        console.error("Failed to copy to clipboard");
      }
    };

    function RowClick(event: any) {
      // console.log(event.data)
      debugger;

      // rowFocus.value = true;
      // Editmodel.value = true;
      // supplierid = event.data.Id;
      router.push({
        path: "/SupplierMasterDetailsView",
        query: {
          Id: PurchaseformData.SupplierId,
          Type: "SupplierId",
        },
      });
    }

    function DeleteSupplier() {
      (PurchaseformData.SupplierId = ""),
        (Data.Address = ""),
        (Data.GST = ""),
        (PurchaseformData.PaymentTermsName = ""),
        (PurchaseformData.DeliveryTermsName = "");
      SupplierCard.value = false;
    }

    function invoiceupdate() {
      emit("update:modelValue", PurchaseformData);
    }

    function change() {
      PurchaseformData.purchase = null;
      PurchaseformData.CreatedAt = "";
      poItems.value = [];
      emit("getPoItems", poItems);
      emit("emitsupplierval", PurchaseformData.SupplierId);
      ListPurchaseOrder();

      if (
        props.showone != "GRN With PO" &&
        props.showone != "DC" &&
        PurchaseformData.SupplierId
      ) {
        DCNoDropdown.value.DCNoId = null;
        DCNoDropdown.value.DCNoOption.length = 0;
        LoadDCNo(PurchaseformData.SupplierId, "Supplier");
      }

      if (props.SelectedDCType == 3) {
        DCSelectedDCType.value = true;
      } else {
        DCSelectedDCType.value = false;
      }
    }

    const DCNoDropdown: any = ref({
      DCNoOption: [],
      DCNoId: ref(),
    });

    async function LoadDCNo(Id, value) {
      debugger;
      let response;
      if (Id && value == "PO") {
        response = await StockInService.GetDCDocNoByPOId(Id);
      } else {
        response = await StockInService.GetDCDocNoBySupplierId(
          Id,
          route.query.StoreId,
          route.query.BranchId
        );
      }

      console.log(response["result"]);
      if (response["result"].length) {
        DCNoDropdown.value.DCNoOption = response["result"].map((item) => {
          item.name = item.DocNo;
          item.value = item.Id;
          return item;
        });
      }

      emit("DCNoDropdownLength", DCNoDropdown.value.DCNoOption.length);

      if (DCNoDropdown.value.DCNoOption.length >= 1) {
        toast.add({
          severity: "info",
          summary: "Note:",
          detail:
            props.showone == "GRN With PO"
              ? "The purchase order you selected contains Delivery Challan (DC) items."
              : "The supplier you selected has associated Delivery Challan (DC) items.",
          life: 4000,
        });
      }
    }

    async function DCNochange() {
      debugger;

      if (Array.isArray(DCNoDropdown.value.DCNoId)) {
        const selectedDCNoIds = DCNoDropdown.value.DCNoId.join(",");
        const response = await StockInService.GetItemsByDCNoId(selectedDCNoIds);

        if (response["result"].length > 0) {
          response["result"] = response["result"]
            .filter((x) => x.ItemQuantity != 0)
            .map((i1) => {
              i1.ExpiryDate1 = i1.ExpiryDate;

              i1.RequestedQty = i1.ItemQuantity;
              i1.IsFreeItem = 0;
              i1.StockDetailsId = 0;

              let BeforeDiscountRate = i1.Rate;

              const discountAmount = ((i1.ItemDiscount || 0.0) / 100) * i1.Rate;
              i1.Discountamount = discountAmount.toFixed(2);

              i1.Rate = (i1.Rate - i1.Discountamount).toFixed(2);

              i1.Purchasetaxamount = (
                i1.Rate *
                (i1.PurchasePercentage / 100)
              ).toFixed(2);

              if (i1.SGSTTax && i1.CGSTTax) {
                i1.SGSTTaxAmount = Number(
                  Number(i1.Purchasetaxamount) / 2
                ).toFixed(2);

                i1.CGSTTaxAmount = Number(
                  Number(i1.Purchasetaxamount) / 2
                ).toFixed(2);
              }

              if (i1.IGSTTax) {
                i1.IGSTTaxAmount = Number(
                  (i1.PurchasePercentage * i1.Rate) / 100
                ).toFixed(2);
              }

              i1.Rate = BeforeDiscountRate;

              i1.Totalvalue = Number(
                Number(i1.Rate) -
                  Number(i1.Discountamount) +
                  Number(i1.Purchasetaxamount) +
                  Number(i1.servicecharges || 0.0) +
                  Number(i1.othercharges || 0.0)
              ).toFixed(2);

              return i1;
            });

          if (props.showone == "GRN With PO") {
            poItems.value = [
              ...poItems.value.filter(
                (item) => item.DocType != "19" && item.DCType !== 3
              ),
              ...response["result"],
            ];
          } else if (props.showone == "GRN Without PO") {
            poItems.value = [
              ...poItems.value.filter(
                (item) => item.DocType != "19" && item.DCType !== 4
              ),
              ...response["result"],
            ];
          } else {
            poItems.value = response["result"];
          }

          emit("getPoItems", poItems);
        } else {
          if (props.showone == "GRN With PO") {
            poItems.value = poItems.value.filter(
              (item) => item.DocType != "19" && item.DCType !== 3
            );
          } else {
            poItems.value = poItems.value.filter(
              (item) => item.DocType != "19" && item.DCType !== 4
            );
          }

          emit("getPoItems", poItems);
        }
      } else {
        console.error("DCNoDropdown.value.DCNoId is not an array");
      }
    }

    /*--*/
    return {
      dataOptions,
      PurchaseformData,
      poOnChange,
      update,
      ListPurchaseOrder,
      EditSupDet,
      Data,
      form,
      supplierupdate,
      // SupformData,
      getfindonedata,
      paymentcategory,
      deliverycategory,
      // data,
      supcategory,
      suppliercategorydd,
      copyGST,
      RowClick,
      showText,
      tooltipContent,
      SupplierCard,
      DeleteSupplier,
      supDisabled,
      displayterms,
      PaymentFunction,
      DeliveryFunction,
      invoiceupdate,
      maxDate,
      change,
      DCNochange,
      DCNoDropdown,
      DCSelectedDCType,
      Param,
    };
  },
  created() {
    // this.getfindonedata()
    this.suppliercategorydd();
  },
});
</script>
<style lang="scss" scoped>
.fieldlabel {
  color: #000000;
  display: inline-block;
  margin-bottom: 0.5rem;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
}

.SupplierCard {
  background-color: #fff;
  min-width: 300px;
}

.SupplierCardgst {
  background-color: rgb(250, 250, 250);
}

.SupplierCardgst .pi {
  display: none;
}

.SupplierCardgst:hover .pi {
  display: block;
}

.copyicon {
  cursor: pointer !important;
}

.suppliercardcontent .pi-external-link {
  display: none;
}

.suppliercardcontent:hover .pi-external-link {
  display: block;
}

.contentbg {
  background-color: #f5f5f5;
  padding: 10px;
  font-size: 14px;
  color: #999999;
}

.supplier-toggle {
  all: unset;
  color: #3096ff;
  font-size: 14px;
  position: absolute;
  right: 10%;
}

.supplier-toggle:enabled:hover {
  all: unset;
  color: #3096ff;
  font-size: 14px;
  position: absolute;
  right: 10%;
}
</style>
<style>
.popover {
  max-width: 350px !important;
}
</style>
